<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
                <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                    <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_BUILDING_FIX_SIZE_ADD')" @click="showCadastreBuildingFixSizeEditModal(null)">{{$t("action.add")}}</button>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>Код</th>
                        <th>Текст</th>
                        <th>Текст(ru)</th>
                        <th>Фойдаланиш мақсади</th>
                        <th class="text-center">{{$t("realEstate.field.action")}}</th>
                    </tr>
                    </thead>
                    <tbody v-if="!loading && results && results.data">
                    <tr v-for="result in results.data" :key="result.id">
                        <td>{{result.code}}</td>
                        <td>{{result.name}}</td>
                        <td>{{result.nameRu}}</td>
                        <td>{{result.buildingType ? result.buildingType.name : ''}}</td>
                        <td class="td-actions text-center">
                            <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showCadastreBuildingFixSizeEditModal(result)">
                                <i class="fa fa-edit"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreBuildingFixSizeEditModal />
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import CadastreBuildingFixSizeEditModal from "@/views/config/cadastre/CadastreBuildingFixSizeEditModal";
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-pagination': bPagination,
            CadastreBuildingFixSizeEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('/cadastre/building/fix-by-size/list', this.filter)
                    .then(res => {
                        vm.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showCadastreBuildingFixSizeEditModal(data) {
                this.$eventBus.$emit('showCadastreBuildingFixSizeEditModal', data);
            }
        },
        created() {
            this.initList()
            this.$eventBus.$on('cadastreBuildingFixSizeChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>